module.exports = __webpack_public_path__ + "static/media/user.e4549788.svg";